// src/app/pages/gap-check/components/questions/questions.component.ts
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GapCheckSection } from '../../../../shared/models/gap-check-section';

@Component({
  selector: 'app-questions',
  standalone: true, // ✅ mark as standalone
  imports: [CommonModule, FormsModule], // import needed modules
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './questions.html',
})
export class QuestionsComponent {
  @Input() questions: GapCheckSection[] = [];
  @Input() currentStep = 0;
}
